import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { formatISO } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import {
  Account_Priority,
  CalculationBalance,
  ClearRisk_level_id,
  RiskBalance,
  SelectedAccount,
  SelectedAsset,
  UserDetails,
  addAccountPriority,
  getCalculationBalance,
  getRiskBalance,
  selectAccount,
  storeRiskLevel1,
  storeRiskLevel2,
  storeRiskLevel3,
} from "../../redux/userSlice";
import axios from "axios";
import { toast } from "react-toastify";
import UseRiskLevel1 from "../CustomHook/UseRiskLevel1";

const ModalFrom = ({
  setmodalStatus,
  modalStatus,
  AccountStatus_function,
  modalStatus_function,
  AccountsStatus_Firstvalue,
  MoneyManagement_show,
  setExperinece_Id,
  LoaderModal,
}) => {
  // for loading modal ==>

  const APi_Url = process.env.REACT_APP_ENIGMA_API;
  // console.log("api url",APi_Url);
  const dispatch = useDispatch();
  const userDetails = useSelector(UserDetails);
  const CalculationResponse = useSelector(CalculationBalance);
  const token = userDetails?.token;

  const [traillingData, setTraillingdata] = useState([]);
  const [winrateData, setWinrateData] = useState([]);
  const [riskData, setRiskData] = useState([]);
  const [experienceType, setExperienceType] = useState([]);

  const [tradingSession, setTradingSession] = useState([]);
  const [tradingWeek, setTradingWeek] = useState([]);
  const [timeTrade, setTimeTrade] = useState([]);

  const riskBalanceDetails = useSelector(RiskBalance);
  const accountPriority = useSelector(Account_Priority);
  // console.log("accountPriority",accountPriority);

  const selectedAccountDetails = useSelector(SelectedAccount);
  const selectedAssetDetails = useSelector(SelectedAsset);

  // .trailingDrawdown
  // .winRate

  useEffect(() => {
    if (userDetails) {
      fetchData();
    }
  }, [selectedAccountDetails?.accountName]);

  // useEffect(()=>{
  //   showRiskLevelCalculation()
  // },[])

  const fetchData = () => {
    showwinrateOptions();
    showriskRewardOptions();
    showwintraillingOptions();
    showriskexperienceTypeOptions();
    showTradingesseionOptions();
    showTradePerWeekOptions();
    showTimeForTradeOptions();
  };

  const showRiskLevelCalculation = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-List/${userDetails.id}/${selectedAccountDetails?.accountId}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(
        "response get-all-risk-level inside modal form",
        response?.data?.response[0]
      );
      if (response?.data?.response[0]) {
        // console.log("response?.data?.response[0]",response?.data?.response[0])
        const RISK_Leveldata = response?.data?.response[0];
        Asset_inputs(selectedAssetDetails.assetId, RISK_Leveldata);
        dispatch(
          getCalculationBalance(response.data.response[0]),
          // dispatch(
          //   getCalculationBalance("Modal form"),

          getRiskBalance({
            risk_balance: {
              riskReward: response.data.response[0].riskReward,
              trailingDrawdown: response.data.response[0].trailingDrawdown,
              winRate: response.data.response[0].winRate,
            },
          })
        );
      } else {
        dispatch(getCalculationBalance(null));
        dispatch(storeRiskLevel1(null));
        dispatch(storeRiskLevel2(null));
        dispatch(storeRiskLevel3(null));
      }

      // Handle response data as needed
    } catch (error) {
      console.error("get-all-risk-level Error ", error);
    }
  };

  // this function call for show windarte option data
  const showwintraillingOptions = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevel/get-all-TrailingDrawdown-Amount`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

    
      const sortedEmploymentData = response?.data?.response?.sort(
  (a, b) => a.trailingAmount - b.trailingAmount
);
  // console.log("response trailling", sortedEmploymentData);
      setTraillingdata(response.data.response);
      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };

  // this function call for show windarte option data
  const showwinrateOptions = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevel/get-all-Risk-Win_Rate`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("response winrate", response.data.response);
      setWinrateData(response.data.response);
      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };

  // this function call for show risk/reward option data
  const showriskRewardOptions = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevel/get-all-Risk-Reward`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("response risk reward", response.data.response);
      setRiskData(response.data.response);
      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };

  // this function call for show risk/reward option data
  const showriskexperienceTypeOptions = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevel/get-all-Experience-Level`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setExperienceType(response.data.response);
      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };

  // this function call for show TradingSession option data
  const showTradingesseionOptions = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevel/get-all-GetAll-TradingSession`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setTradingSession(response.data.response);
      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };

  // this function call for show Trades per week option data
  const showTradePerWeekOptions = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevel/get-all-GetAll-TradsPerWeek`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setTradingWeek(response.data.response);
      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };

  // this function call for show Time for Trade option data
  const showTimeForTradeOptions = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevel/get-all-GetAll-TimeForTrades`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setTimeTrade(response.data.response);
      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };

  const handleModalClose = (resetForm) => {
    resetForm();
    setmodalStatus(false);

    dispatch(addAccountPriority(""));
  };

  const initialValues = {
    accountName:
      accountPriority == "update"
        ? selectedAccountDetails?.accountName || ""
        : accountPriority == "add"
        ? ""
        : selectedAccountDetails?.accountName || "",
    trailingDrawdown:
      accountPriority == "update"
        ? CalculationResponse?.trailingDrawdown || ""
        : accountPriority == "add"
        ? ""
        : CalculationResponse?.trailingDrawdown || "",
    winRate:
      accountPriority == "update"
        ? CalculationResponse?.winRate || ""
        : accountPriority == "add"
        ? ""
        : CalculationResponse?.winRate || "",

    riskReward:
      accountPriority == "update"
        ? CalculationResponse?.riskReward || ""
        : accountPriority == "add"
        ? ""
        : CalculationResponse?.riskReward || "",
    experienceType:
      accountPriority == "update"
        ? CalculationResponse?.experienceId || ""
        : accountPriority == "add"
        ? ""
        : CalculationResponse?.experienceId || "",

    SessionType:
      accountPriority == "update"
        ? CalculationResponse?.sessionType || "0"
        : accountPriority == "add"
        ? "0"
        : CalculationResponse?.sessionType || "0",

    TradePerweek:
      accountPriority == "update"
        ? CalculationResponse?.tradePerweek || "0"
        : accountPriority == "add"
        ? "0"
        : CalculationResponse?.tradePerweek || "0",
    TradesTime:
      accountPriority == "update"
        ? CalculationResponse?.tradesTime || "0"
        : accountPriority == "add"
        ? "0"
        : CalculationResponse?.tradesTime || "0",
  };
  const validationSchema = Yup.object({
    accountName: Yup.string()
      .min(3, "Account name must be at least 3 characters")
      .required("Account name is Required"),
    trailingDrawdown: Yup.string().required(
      "Please provide Trailling Drawdown ."
    ),
    winRate: Yup.string().required("Please select winRate"),
    riskReward: Yup.string().required("Please select Risk/Reward"),
    experienceType: Yup.string().required("Please select Experience Level"),
  });
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const today = new Date();
  const createdDate = formatISO(today);
  const onSubmit = async (values, { setSubmitting }) => {
    //  Account create in modal form api call start

    const data = {
      accountName: capitalizeFirstLetter(values.accountName),
      displayPriority: 1,
      createdDate: createdDate,
      userId: userDetails.id,
      createdBy: userDetails.id,
      deletedDate: createdDate,
      deletedBy: 0,
    };
    const updatedDateData = {
      srcAccountId: selectedAccountDetails.accountId,
      accountName: capitalizeFirstLetter(values.accountName),
      userId: userDetails.id,
    };
    //  "#accountModal".modal("hide");
    // isDeleted: true,
    if (accountPriority == "update") {
      LoaderModal(true);
      try {
        const response = await axios.post(
          `${APi_Url}api/account/update-source-account`,
          updatedDateData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("update account response", response.data.response);

        if (response.data.success == true) {
          toast.success("Successfully update account");
          RiskLevelCalculation(
            values,
            setSubmitting,
            selectedAccountDetails.accountId
          );
          dispatch(addAccountPriority(""));
          dispatch(
            selectAccount({
              account: {
                accountId: response?.data?.response?.srcAccountId,
                accountName: response?.data?.response?.accountName,
                accountStatus: true,
              },
            })
          );
          AccountsStatus_Firstvalue();
        }
      } catch (error) {
        console.error("Error ", error);
      }
      //
    } else if (accountPriority == "add") {
      LoaderModal(true);
      try {
        const response = await axios.post(
          `${APi_Url}api/account/create-source-account`,
          data,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success == true) {
          toast.success("Successfully add account");
          RiskLevelCalculation(
            values,
            setSubmitting,
            response?.data?.response?.sourceAccountId
          );
          dispatch(addAccountPriority(""));
          dispatch(
            selectAccount({
              account: {
                accountId: response?.data?.response?.sourceAccountId,
                accountName: response?.data?.response?.accountName,
                accountStatus: true,
              },
            })
          );
          AccountsStatus_Firstvalue();
        }
      } catch (error) {
        console.error("Error ", error);
      }
    } else {
      LoaderModal(true);
      try {
        const response = await axios.post(
          `${APi_Url}api/account/update-source-account`,
          updatedDateData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("update account response", response.data.response);

        if (response.data.success == true) {
          toast.success("Successfully update account");
          RiskLevelCalculation(
            values,
            setSubmitting,
            selectedAccountDetails.accountId
          );
          dispatch(addAccountPriority(""));
          dispatch(
            selectAccount({
              account: {
                accountId: response?.data?.response?.srcAccountId,
                accountName: response?.data?.response?.accountName,
                accountStatus: true,
              },
            })
          );
          AccountsStatus_Firstvalue();
        }
      } catch (error) {
        console.error("Error ", error);
      }
    }

    //  Account create in modal form api call end
  };

  // this function called for RiskLevelCalculation
  const RiskLevelCalculation = async (values, setSubmitting, accountId) => {
    try {
      const response = await axios.post(
        `https://enigmaapi.smarttradingblueprint.com/api/RiskLevelCalculation/Risk-Level-Calculation/${userDetails.id}/${values.trailingDrawdown}/${accountId}/${values.winRate}/${values.riskReward}/${values.experienceType}/${values.SessionType}/${values.TradePerweek}/${values.TradesTime}`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            secure: false,
            changeOrigin: true,
          },
        }
      );

      // console.log("RESPONSE calculation ", response.data.response[0]);
      LoaderModal(false);
      setmodalStatus(false);
      toast.success("Successfully Risk Level calculated");
      showRiskLevelCalculation();
      AccountStatus_function();
      modalStatus_function();
      AccountsStatus_Firstvalue();
      MoneyManagement_show();
      setExperinece_Id(values.experienceType);
      dispatch(ClearRisk_level_id());

      dispatch(addAccountPriority(""));
      // console.log("values.experienceType",values.experienceType)
      // resetForm();
    } catch (error) {
      // console.error("Error ", error?.response);
      if (error?.response?.status == 400) {
        toast.error(error.response.data.response);
        LoaderModal(false);
        // modalStatus_function();
        // setmodalStatus(false);

        dispatch(addAccountPriority(""));
      }
    } finally {
      setSubmitting(false); // Make sure to reset form state, if applicable
    }
  };

  // This function called for asset calculation
  const Asset_inputs = async (id, risk_level_data) => {
    try {
      const response = await axios.get(
        `${APi_Url}api/AssetList/get-Asset-inputs-by-assetlistid/${id}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const assetData = response.data.response;
      if (id === 1 || id === 3 || id === 5 || id === 7) {
        onSubmit_RiskLevelCalculation(
          id,
          assetData,
          "Asset_Calculation_For_CL_ES_NQ_YM",
          risk_level_data
        );
      } else {
        onSubmit_RiskLevelCalculation(
          id,
          assetData,
          "Asset_Calculation_For_MCL_MES_MYM_MNQ",
          risk_level_data
        );
      }
      // Handle response data as needed
    } catch (error) {
      // console.error("Error ", error);
    }
  };

  // RiskLevelCalculation/Risk-Level1-Calculation api called
  const onSubmit_RiskLevelCalculation = async (
    assetid,
    responseAssetdata,
    apiEndPoint,
    risk_level_data
  ) => {
    const initialValues = {
      pointValue: responseAssetdata ? responseAssetdata.pointValue : "",
      accountId: selectedAccountDetails?.accountId,
      tickSize: responseAssetdata ? responseAssetdata.tickSize : "",
      rtComms: responseAssetdata ? responseAssetdata.rtComms : "",
      trailStop1: responseAssetdata ? responseAssetdata.trailStop1 : "",
      trailStop2: responseAssetdata ? responseAssetdata.trailStop2 : "",
      be: responseAssetdata ? responseAssetdata.be : "",
      tP1: responseAssetdata ? responseAssetdata.tP1 : "",
      tP2: responseAssetdata ? responseAssetdata.tP2 : "",
      tP3: responseAssetdata ? responseAssetdata.tP3 : "",
      tP4: responseAssetdata ? responseAssetdata.tP4 : "",
    };
    // console.log("assetid on response",initialValues)

    const data = {
      ...initialValues,
      userId: userDetails.id,
      assetId: assetid,
      riskLevel1: risk_level_data
        ? parseFloat(risk_level_data?.aggressiveDRPT)
        : "",
      riskLevel2: risk_level_data
        ? parseFloat(risk_level_data?.neutralDRPT)
        : "",
      riskLevel3: risk_level_data
        ? parseFloat(risk_level_data?.conservativeDRPT)
        : "",
    };

    const stringData = {};

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        // console.log("data[key].toString();", data[key].toString());
        stringData[key] = data[key].toString();
      }
    }

    const from_Data = JSON.stringify(stringData);

    try {
      const response = await axios.post(
        `${APi_Url}api/RiskLevelCalculation/${apiEndPoint}`,
        from_Data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("resonse onSubmit_RiskLevelCalculation",response)

      if (response.data.statusCode === 200) {
        // toast.success(response.data.response);

        // window.location.href = '/account2';
        get_RiskLevel1(assetid);
        get_RiskLevel2(assetid);
        get_RiskLevel3(assetid);
        // navigate('/account2', { replace: true })
        // UseRiskLevel1(assetid);
      }
    } catch (error) {
      console.error("Error ", error);
    }
  };

  // Risk level 1
  const get_RiskLevel1 = async (id) => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-1/${userDetails.id}/${id}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch(storeRiskLevel1(response.data.response));
      // setRisk_Level1(response.data.response);

      // Handle response data as needed
    } catch (error) {
      // console.error("Error ", error);
    }
  };
  // Risk level 2
  const get_RiskLevel2 = async (id) => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-2/${userDetails.id}/${id}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(storeRiskLevel2(response.data.response));

      // Handle response data as needed
    } catch (error) {
      // console.error("Error ", error);
    }
  };
  // Risk Level 3
  const get_RiskLevel3 = async (id) => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-3/${userDetails.id}/${id}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch(storeRiskLevel3(response.data.response));

      // Handle response data as needed
    } catch (error) {
      // console.error("Error ", error);
    }
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize={true}
      >
        {({ handleSubmit, isSubmitting, isValid, values, resetForm }) => (
          <Form
            className="row needs-validation"
            noValidate
            onSubmit={handleSubmit}
          >
            <div className="col-md-12">
              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Account Name<span>*</span>
                </label>
                <div className="col-sm-7">
                  <Field
                    type="text"
                    id="accountName"
                    name="accountName"
                    placeholder="Input here"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="accountName"
                    component="div"
                    className="error_msg"
                  />
                </div>
              </div>

              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Select Trailing Drawdown<span>*</span>
                </label>
                <div className="col-sm-7">
                  <Field
                    as="select"
                    id="trailingDrawdown"
                    name="trailingDrawdown"
                    className="form-control"
                  >
                    <option value="">Select Trailing Drawdown </option>
                    {traillingData.map((item) => (
                      <option
                        key={item.trailingDrawdowId}
                        value={item.trailingAmount}
                      >
                        {item.trailingAmount}
                      </option>
                    ))}
                  </Field>

                  <ErrorMessage
                    name="trailingDrawdown"
                    component="div"
                    className="error_msg"
                  />
                </div>
              </div>

              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Select Win Rate<span>*</span>
                </label>
                <div className="col-sm-7">
                  <Field as="select" name="winRate" className="form-control">
                    <option value="">Select Win Rate</option>{" "}
                    {winrateData.map((item) => (
                      <option key={item.winRateId} value={item.winRate}>
                        {item.winRate * 100 + "%"}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="winRate"
                    component="div"
                    className="error_msg"
                  />
                </div>
              </div>

              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Select Risk/Reward<span>*</span>
                </label>
                <div className="col-sm-7">
                  <Field as="select" name="riskReward" className="form-control">
                    <option value="">Select Risk/Reward</option>{" "}
                    {riskData.map((item) => (
                      <option key={item.riskRewardId} value={item.reward}>
                        {item.reward}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="riskReward"
                    component="div"
                    className="error_msg"
                  />
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Select Experience Level<span>*</span>
                </label>
                <div className="col-sm-7">
                  <Field
                    as="select"
                    name="experienceType"
                    className="form-control"
                  >
                    <option value="">Select Experience Level</option>{" "}
                    {experienceType.map((item) => (
                      <option key={item.experienceId} value={item.experienceId}>
                        {item.experienceType}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="experienceType"
                    component="div"
                    className="error_msg"
                  />
                </div>
              </div>
              {/* Trading Session */}
              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Select Trading Session
                </label>
                <div className="col-sm-7">
                  <Field
                    as="select"
                    name="SessionType"
                    className="form-control"
                  >
                    <option value="0">Select Trading Session</option>{" "}
                    {tradingSession.map((item) => (
                      <option key={item.tsId} value={item.tsId}>
                        {item.session}
                      </option>
                    ))}
                  </Field>
                  {/* <ErrorMessage
                  name="SessionType"
                  component="div"
                  className="error_msg"
                /> */}
                </div>
              </div>
              {/* Trades Per Week */}
              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Trades Per Week
                </label>
                <div className="col-sm-7">
                  <Field
                    as="select"
                    name="TradePerweek"
                    className="form-control"
                  >
                    {/* {values.riskReward ? (
                    <> */}
                    <option value="0">Select Trades Per Week</option>{" "}
                    {tradingWeek.map((item) => (
                      <option key={item.tpwId} value={item.tpwId}>
                        {item.numberOfTrades}
                      </option>
                    ))}
                    {/* </>
                  ) : (
                    <option value="">Select Risk/Reward</option>
                  )} */}
                  </Field>
                  {/* <ErrorMessage
                  name="TradePerweek"
                  component="div"
                  className="error_msg"
                /> */}
                </div>
              </div>
              {/* Time for Trades */}
              <div className="row mb-3">
                <label className="col-sm-5 col-form-label">
                  Time for Trades
                </label>
                <div className="col-sm-7">
                  <Field as="select" name="TradesTime" className="form-control">
                    {/* {values.riskReward ? (
                    <> */}
                    <option value="0">Select Time for Trades</option>{" "}
                    {timeTrade.map((item) => (
                      <option key={item.tftId} value={item.tftId}>
                        {item.tradesTime}
                      </option>
                    ))}
                    {/* </>
                  ) : (
                    <option value="">Select Risk/Reward</option>
                  )} */}
                  </Field>
                  {/* <ErrorMessage
                  name="TradesTime"
                  component="div"
                  className="error_msg"
                /> */}
                </div>
              </div>
            </div>

            <div className="col-12">
              <button className="btn kevlar_btn" type="submit">
                Submit
              </button>

              {modalStatus ? (
                <button
                  className="btn kevlar_btn"
                  onClick={() => handleModalClose(resetForm)}
                  type="button"
                >
                  Cancel
                </button>
              ) : (
                ""
              )}
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
export default ModalFrom;
